import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'
import { IDevice } from '@/data/models/Device'

export class DeviceApiService extends ApiService {
  static async getAll(): Promise<IServiceResponse<Array<IDevice>>> {
    return this.axios.get('devices')
      .then((response: AxiosResponse<IServiceResponse<Array<IDevice>>>) => response.data)
  }

  static async create(data: IDevice): Promise<IServiceResponse<IDevice>> {
    return this.axios.post('devices', data)
      .then((response: AxiosResponse<IServiceResponse<IDevice>>) => response.data)
  }

  static async update(data: IDevice): Promise<IServiceResponse<IDevice>> {
    return this.axios.put(`devices/${data.id}`, data)
      .then((response: AxiosResponse<IServiceResponse<IDevice>>) => response.data)
  }

  static async delete(id: number): Promise<IServiceResponse<boolean>> {
    return this.axios.delete(`devices/${id}`)
      .then((response: AxiosResponse<IServiceResponse<boolean>>) => response.data)
  }

  static async fieldwizSyncDevices(): Promise<IServiceResponse<Array<IDevice>>> {
    return this.axios.get('devices/fieldwiz-sync')
      .then((response: AxiosResponse<IServiceResponse<Array<IDevice>>>) => response.data)
  }
}
